import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m36.142.787 7.071 7.07-14.142 14.143 14.142 14.142-7.07 7.071-14.143-14.142-14.142 14.142-7.071-7.07 14.142-14.143-14.142-14.142 7.07-7.071 14.143 14.142z",
  fill: "#111224",
  opacity: ".1"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }